import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { CartDrawer } from '@components/CartDrawer/CartDrawer'
import Header from '@components/Header'
import renderLiquidLinks from '@components/Header/utils/renderLiquidLinks'
import { WishlistDrawer } from '@components/WishlistDrawer/WishlistDrawer'
import {
  withApollo,
  withErrorBoundary,
  withExchangeRates,
  withI18next,
  withStaffPickImage,
  withTheme,
} from '@hocs'
import type { CartDrawerData } from '@velasca/types'
import { withWishlist } from '../hocs/withWishlist'

export const renderHeaderApp = (
  homePageEl: HTMLElement | null,
  switchCountryEl: HTMLElement | null,
  cartPageEl: HTMLElement | null,
  giftCardProductEl: HTMLElement | null,
  apparelProductEl: HTMLElement | null,
  apparelCategoryEl: HTMLElement | null,
  apparelMacroCategoryEl: HTMLElement | null,
  cartDrawerData: CartDrawerData,
  headerEl: HTMLElement | null,
  headerDataEl: HTMLElement | null,
  headerData: any,
  promotionalBannerData: any,
  minisearchData: any,
) => {
  if (
    !giftCardProductEl &&
    !apparelProductEl &&
    !apparelCategoryEl &&
    !apparelMacroCategoryEl &&
    !cartPageEl &&
    !homePageEl &&
    headerEl &&
    headerDataEl
  ) {
    const HeaderApp = () => (
      <>
        <CartDrawer
          emptyCartCtas={cartDrawerData?.ctas || []}
          editorialSuggestedProductsDesktopImage={
            cartDrawerData?.editorial?.suggestedProductsDesktopImage
          }
        />
        <WishlistDrawer />
        <Header
          promotionalBanner={promotionalBannerData || {}}
          miscHeaderData={headerData?.miscData}
          minisearch={minisearchData}
          reduced={headerEl.getAttribute('data-reduced') === 'true' || false}
          lowerMenu={headerData?.mobileOnlyNav}
          menu={
            renderLiquidLinks(
              headerData?.nav,
              headerData?.miscData?.liquidLinks,
            ) ?? undefined
          }
          sticky={
            headerEl.getAttribute('data-sticky') === 'true' ||
            switchCountryEl?.getAttribute('data-header-sticky') ||
            false
          }
        />
      </>
    )

    const HeaderAppWrapper = pipe(
      HeaderApp,
      withStaffPickImage,
      withExchangeRates,
      withWishlist,
      withI18next,
      withErrorBoundary,
      withTheme,
      withApollo,
    )

    ReactDOM.createRoot(headerEl).render(<HeaderAppWrapper />)
  }
}
